export default {
  'driver-list': ['driver_management'],
  'driver-category': ['driver_category_management']
}
